<template>
  <b-modal id="view_note_modal" ref="view_note_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1>
          <i class="far fa-sticky-note"></i>
          <span>{{ note.note_type.note_type }}</span>
        </h1>
        <p id="mh-info">
          <span style="font-size: 0.65rem;">Created By: {{ note.note_log_by.first_name }} {{ note.note_log_by.surname }} on {{ note.note_logs.updated_at |formatDateTime }}</span>
        </p>
      </div>
      <button id="mh-close" class="btn-close" v-on:click="hideModal()"><i class="fas fa-times"></i></button>
    </div>
    <!--    <p><strong>Note On {{ $store.state.notes.type | capitalWords }}:</strong> {{ $store.state.notes.name }}</p>-->


    <div class="row mb-3">
      <div class="col-6"><strong>Call Note</strong></div>
      <div class="col-6">
        <span v-if="note.is_call">Yes</span><span v-else>No</span>
      </div>
      <div v-if="note.is_call" class="col-6"><strong>Voicemail Left</strong></div>
      <div v-if="note.is_call" class="col-6">
        <span v-if="note.voicemail">Yes</span><span v-else>No</span>
      </div>
      <div v-if="note.is_call" class="col-6"><strong>Call Type</strong></div>
      <div v-if="note.is_call" class="col-6">
        {{note.call_type}}
      </div>
    </div>

    <div class="row mb-3" v-if="note.worker_id === null">
      <div class="col-6"><strong>Decision Maker Call</strong></div>
      <div class="col-6">
        <span v-if="note.decision_maker">Yes</span><span v-else>No</span>
      </div>
    </div>
    <div class="row mb-3" v-if="note.worker_id !== null && note.is_call">
      <div class="col-6"><strong>Discussed Tax</strong></div>
      <div class="col-6">
        <span v-if="note.discussed_tax">Yes</span><span v-else>No</span>
      </div>
      <div v-if="note.discussed_tax" class="col-6"><strong>Sold Tax</strong></div>
      <div v-if="note.discussed_tax" class="col-6"><span v-if="note.sold_tax">Yes</span><span v-else>No</span>
      </div>
    </div>

    <pre>{{ note.note }}</pre>
    <div class="row mt-4"
         v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager')) || $store.state.auth.me.id === note.note_log_by.id">
      <div class="col-md-6">
        <button v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager')) || ($store.state.auth.me.id === note.note_log_by.id  &&
        this.can_delete)" class="btn orcaBtn danger w-100 sm_btn" data-toggle="tooltip" title="Delete Worker Note" @click.prevent="deleteNote">Delete
        </button>
      </div>
      <div class="col-md-6">
        <button v-if="($store.state.auth.me.roles.includes('admin') || $store.state.auth.me.roles.includes('manager')) || ($store.state.auth.me.id === note.note_log_by.id  &&
        this.can_delete)" class="btn orcaBtn greenBtn w-100 sm_btn" data-toggle="tooltip" title="Edit Worker Note" @click.prevent="editNote">Edit
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "view_note",
  data() {
    return {
      note: {
        note_logs: {},
        note_log_by: {},
        belongs_to: {},
        note_type: {},
      }
    }
  },
  mounted() {
    axios.get(this.crmApiPath + 'note/' + this.$store.state.notes.id).then(note => this.note = note.data)
  },
  computed: {
    can_delete() {
      let note_created_add_10_minutes = this.$moment(this.note.created_at).utc().add(10, 'minutes');
      let can_delete = false;
      if (this.$moment().utc() < note_created_add_10_minutes) {
        can_delete = true;
      }
      return can_delete;
    }
  },
  methods: {
    hideModal() {
      this.$refs.view_note_modal.hide();
      this.$store.commit('HIDE_NOTE_MODALS');
    },
    deleteNote() {
      // add log values
      this.note.log_by_type = 'App\\Models\\Users\\User';
      this.note.log_by_id = this.$store.state.auth.me.id;
      // confirm delete dialog
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Delete Note</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to delete this note?' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-trash-alt"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              axios.delete(this.crmApiPath + 'note/' + this.$store.state.notes.id, {data: this.note}).then(() => {
                this.$bus.$emit('note::reload', {action: true});
                this.$bus.$emit('logs::reload', {action: true});
                this.hideModal();
              })
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    },
    editNote() {
      if (this.$store.state.notes.type === 'worker') {
        this.$store.commit('SHOW_EDIT_NOTE_MODAL', {
          id: this.$store.state.notes.id,
          name: this.$store.state.notes.name,
          type: 'worker',
          contacts: null
        });
      }
      if (this.$store.state.notes.type === 'company') {
        this.$store.commit('SHOW_EDIT_NOTE_MODAL', {
          id: this.$store.state.notes.id,
          name: this.$store.state.notes.name,
          type: 'company',
          contacts: this.$store.state.notes.contacts
        });
      }
      if (this.$store.state.notes.type === 'contact') {
        this.$store.commit('SHOW_EDIT_NOTE_MODAL', {
          id: this.$store.state.notes.id,
          name: this.$store.state.notes.name,
          type: 'contact',
          contacts: null
        });
      }
      if (this.$store.state.notes.type === 'order_job') {
        this.$store.commit('SHOW_EDIT_NOTE_MODAL', {
          id: this.$store.state.notes.id,
          name: this.$store.state.notes.name,
          type: 'order_job',
          contacts: null
        });
      }
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'edit_note_modal'))
    }
  }
}
</script>

<style scoped lang="scss">
pre {
  font-family: $font-family-paragraph;
  font-size:   0.8rem;
}
</style>
